import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en.json";
import lv from "./locales/lv.json";

// Configure i18next
i18n
  .use(initReactI18next) // Connects i18next to React
  .use(LanguageDetector) // Detects user language from browser settings
  .init({
    resources: {
      en: { translation: en },
      lv: { translation: lv },
    },
    lng: "lv", // Default language
    fallbackLng: "en", // Default language
    interpolation: { escapeValue: false }, // No need for escaping HTML
  });

export default i18n;
